import React from 'react'

const Page404 = () => {
  
const styles = {
  container: {
    textAlign: 'center',
    marginTop: '100px',
  },
  title: {
    fontSize: '70px',
    color: '#333',
  },
  description: {
    fontSize: '30px',
    color: '#666',
  },
};
  return (
    <div style={styles.container}>
       <h1 style={styles.title}>404 - Page Not Found</h1>
      <p style={styles.description}>Oops! The page you are looking for doesn't exist.</p>
    </div>
  )
}

export default Page404